import React from 'react';
import PropTypes from 'prop-types';
import Icon from '../Icons/Icon';

const CheckboxControl = ({
  id, label, description, isChecked, onToggle,
}) => (
  <div
    className={`py-6 mb-4 text-left rounded flex items-start transition-all ${
      !isChecked ? 'bg-vamos-light-gray border border-transparent hover:border-vamos-black' : 'bg-vamos-green3 border border-vamos-green3 hover:border-vamos-black'
    }`}
  >
    <button
      type="button"
      className="mr-6 ml-6 flex-shrink-0 focus:outline-none"
      onClick={onToggle}
      id={id}
    >
      <Icon
        name={isChecked ? 'check_box' : 'check_box_outline_blank'}
        className="w-6 h-6 text-vamos-blue-gray"
      />
    </button>
    <label htmlFor={id} className="cursor-pointer">
      <h3 className="font-semibold text-base mb-2">{label}</h3>
      <p className="text-sm font-normal mr-17 leading-[14px]">{description}</p>
    </label>
  </div>
);

CheckboxControl.propTypes = {
  id: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  isChecked: PropTypes.bool.isRequired,
  onToggle: PropTypes.func.isRequired,
};

export default CheckboxControl;
